// extracted by mini-css-extract-plugin
export var figure = "Media-module--figure--3WZy5";
export var mediaContainer = "Media-module--mediaContainer--2jONG";
export var videoUpload = "Media-module--videoUpload--2_cbd";
export var caption = "Media-module--caption--1nW0O";
export var mediaFullWidth = "Media-module--mediaFullWidth--1a44X";
export var grid = "Media-module--grid--2SsiC";
export var container = "Media-module--container--3W8k9";
export var mediaHalfWidth = "Media-module--mediaHalfWidth--1SZJD";
export var mediaOverflowScroll = "Media-module--mediaOverflowScroll--3cuJU";
export var show = "Media-module--show--3WYwj";
export var showFadeInDown = "Media-module--show-fade-in-down--1j7V-";
export var showFadeInUp = "Media-module--show-fade-in-up--2F2Ow";
export var hideFadeOut = "Media-module--hide-fade-out--3svNV";